export const STEP_PATHS = {
  1: ['/booking/step-start/', '/booking/step-register/', '/booking/step-login/'],
  2: [
    '/booking/step-select-pet/',
    '/booking/step-name-pet/',
    '/booking/step-birthday-pet/',
    '/booking/step-lifephase-pet/',
    '/booking/step-gender-pet/',
    '/booking/step-castration-pet/',
    '/booking/step-race-pet/',
    '/booking/step-size-pet/',
    '/booking/step-matted-pet/',
    '/booking/step-visit-pet/',
  ],
  3: [
    '/booking/step-package-selection/',
    '/booking/step-date/',
    '/booking/step-time/',
    '/booking/step-additional-information/',
    '/booking/step-personal-data/',
  ],
  4: ['/booking/step-summary/', '/booking/step-confirmation/'],
};

export const FLOW_DEFAULT = [
  '/booking/step-start/',
  '/booking/step-register/',
  '/booking/step-login/',
  '/booking/step-select-pet/',
  '/booking/step-name-pet/',
  '/booking/step-birthday-pet/',
  '/booking/step-lifephase-pet/',
  '/booking/step-gender-pet/',
  '/booking/step-castration-pet/',
  '/booking/step-race-pet/',
  '/booking/step-size-pet/',
  '/booking/step-matted-pet/',
  '/booking/step-visit-pet/',
  '/booking/step-package-selection/',
  '/booking/step-date/',
  '/booking/step-time/',
  '/booking/step-additional-information/',
  '/booking/step-personal-data/',
  '/booking/step-summary/',
  '/booking/step-confirmation/',
];

export const FLOW_DE = [
  '/booking/step-start/',
  '/booking/step-register/',
  '/booking/step-login/',
  '/booking/step-select-pet/',
  '/booking/step-name-pet/',
  '/booking/step-size-pet/',
  '/booking/step-coat-length/',
  '/booking/step-matted-pet/',
  '/booking/step-visit-pet/',
  '/booking/step-package-selection/',
  // '/booking/step-date-time/', to enable in improvement round
  '/booking/step-date/',
  '/booking/step-time/',
  '/booking/step-additional-information/',
  '/booking/step-personal-data/',
  '/booking/step-summary/',
  '/booking/step-confirmation/',
];
